// extracted by mini-css-extract-plugin
export var base = "_4z-0";
export var updateBanner = "_4z-1";